import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AvatarComponent, UnavailableComponent } from '@shared/components';
import { InitialsPipe, MediaSrcPipe } from '@shared/pipes';
import { InstructorFacade } from '@app/store/instructor';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-instructor-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, AsyncPipe, DatePipe, ButtonModule, AvatarComponent, InitialsPipe, MediaSrcPipe, DeleteButtonComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly instructorFacade = inject(InstructorFacade);

    readonly instructor = this.instructorFacade.instructor;
    readonly loading = this.instructorFacade.loading;
    readonly error = this.instructorFacade.error;
    readonly saving = this.instructorFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.instructorFacade.getInstructor(id);
        }

        effect(() => {
            if (this.instructorFacade.saved()) {
                this.close({ replaceUrl: !this.instructorFacade.instructor() });
            }
        });
    }

    ngOnDestroy(): void {
        this.instructorFacade.clear();
    }

    onEdit(): void {
        const instructor = this.instructor();
        if (instructor) {
            this.router.navigate([{ outlets: { modal: ['instructors', 'edit', instructor.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
